import BulbOutlined from "@ant-design/icons/es/icons/BulbOutlined";
import { CaretUpIcon } from "@phosphor-icons/react";
import { Collapse } from "antd";
type ContextualInfoCollapseProps = {
  title?: string;
  children: string | React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
};
const ContextualInfoCollapse = ({
  title = "How to read these results",
  children,
  icon,
  className
}: ContextualInfoCollapseProps) => <Collapse ghost size="small" defaultActiveKey={0} expandIcon={props => props.isActive ? <CaretUpIcon /> : null} expandIconPlacement="end" className={`rounded-md bg-info p-0 ${className}`} items={[{
  key: "0",
  label: <div className="flex gap-2 text-info-fg">
            {icon ? icon : <BulbOutlined size={15} className="text-info-fg" />} {title}
          </div>,
  children,
  classNames: {
    header: "!px-2 !py-1",
    body: "!px-3 !pt-0 text-info-fg"
  }
}]} data-sentry-element="Collapse" data-sentry-component="ContextualInfoCollapse" data-sentry-source-file="ContextualInfoCollapse.tsx" />;
export default ContextualInfoCollapse;